<template>
  <div class="meetings-container">
    <div class="meetings-informations">
      <div class="meetings-header">
        <img src="/static/banner.png" alt="">
      </div>
        <div id="end-btn">已结束</div>

      </div>
      <div id="menu">
        <a class="flex-item1" href="/meeting.html">深圳站</a>
        <a class="flex-item1" href="/meeting-sh.html">上海站</a>
        <a class="flex-item1" href="javascript:alert('敬请期待')">北京站</a>
        <a class="flex-item1" href="javascript:alert('敬请期待')">广州站</a>
      </div>
      <div class="meetings-main">
        <div>
          <p>以下为本次活动前七场（深圳、杭州、上海、南京站、北京站、成都站、厦门）的上市公司报名入口，望各大上市公司代表积极参与：</p>
        </div>
        <ul class="city-list">
          <li v-for='item in list' :class="[item.limit>0?'city-pass':'city-forbidden']" @click='goCity(item.city)'>{{item.city}}报名
            <span v-if='item.limit<=0'>已结束</span>
          </li>

        </ul>
        <div class="meetings-notice">
          （可同时报不同城市会议）
        </div>
        <div class="meeting-timeline">
          <h3>| 大会时间地点 | </h3>
          <ul>
            <li v-for='item in list'>
              <div class="meetings-city">
                {{item.city}}站
              </div>
              <div class="meetings-info">
                时间：{{item.startTime}}
              </div>
              <div class="meetings-info">
                地点：{{item.position}}
              </div>
              <div class="meetings-info">

                地址：{{item.address}}
              </div>
            </li>


          </ul>
        </div>
        <div class="meeting-contact">
          <h3>| 联系组委会 | </h3>
          <div class="contact-info">
            <div>更多大会咨询，请联络： </div>
            <div>黄涛：13794450949（微信）</div>
            <div>Email：business@gelonghui.com </div>
          </div>
        </div>
      </div>
      <div class="meetings-footer">
        <img src="/static/ft.jpg" alt="">
      </div>
    </div>
  </div>

</template>
<script>
  export default {
    data() {
      return {
        list: []
      }
    },
    methods: {
      //获取场次列表数据
      getData() {
        this.$http.hkstocks_query().then(res => {
          if (res.data.statusCode === 200) {
            this.list = res.data.result
          } else {
            this.list = []
          }
        })
      },
      goCity(city) {
        this.$router.push(`/meetings/hkstocks?city=${city}`)
      }
    },
    mounted() {
      this.getData()
    }
  }

</script>
<style scoped>
  .meetings-container {
    background: url(https://asset.mikecrm.com/getimg/origin/images/formTemplate/img-bmsq-0-0.jpg) repeat;
    height: auto;
    display: block;
    width: 100%;
    position: relative;
    font-size: 14px;
  }

  .meetings-informations {
    width: 560px;
    height: 100%;
    background: #FFF;
    margin: 0 auto;
  }

  .meetings-header img,
  .meetings-footer img {
    width: 100%;
    height: auto;
    display: block;
  }

  .meetings-main p,
  .contact-info div {
    font-size: 14px;
    line-height: 30px;
    margin: 10px 20px;
  }

  .meetings-notice {
    text-align: center;
    font-size: 12px;
  }

  .meeting-timeline h3,
  .meeting-contact h3 {
    border-bottom: 1px solid #666;
    font-weight: 700;
    font-size: 14px;
    line-height: 30px;
    margin: 10px 20px;
  }

  .city-list li {
    width: 40%;
    margin-left: 10%;
    float: left;
    background-color: #AB3B2D;
    color: #FFF;
    line-height: 50px;
    border-radius: 6px;
    text-align: center;
    margin-bottom: 15px;
  }

  .city-list {
    list-style: none;
    width: 90%;
    padding: 0px;
    padding-top: 20px;
    margin: 0 auto;
    margin-left: 0%;
    overflow: hidden;
  }

  .meeting-timeline ul li {
    list-style: none;
    font-size: 14px;
    line-height: 30px;
    margin: 10px 20px;
  }

  .city-list .city-pass {
    cursor: pointer;
  }

  .city-list .city-forbidden {
    pointer-events: none;
    color: grey;
  }

</style>



// WEBPACK FOOTER //
// src/components/frontend/meeting.vue